/**
 * Starter menus for first-run onboarding (ONBOARDING-FIRST-RUN-PLAN.md, Step B).
 *
 * Keyed by the businessType captured at signup. Durations in minutes, prices
 * in pounds. Prices are only prefilled for GBP salons; other currencies get
 * durations and an empty price the owner fills in.
 *
 * DRAFT: to be reviewed by someone who has run each kind of shop.
 */

export const STARTER_MENUS = {
  barber: {
    label: 'barbershops',
    categories: [
      { name: 'Cuts', services: [
        { name: 'Skin Fade', time: 30, price: 22 },
        { name: 'Scissor Cut', time: 30, price: 20 },
        { name: 'Kids Cut', time: 20, price: 14 },
      ] },
      { name: 'Beard and Shave', services: [
        { name: 'Cut and Beard', time: 45, price: 30 },
        { name: 'Beard Trim', time: 15, price: 12 },
        { name: 'Hot Towel Shave', time: 30, price: 20 },
      ] },
    ],
  },
  hair_salon: {
    label: 'hair salons',
    categories: [
      { name: 'Cut and Finish', services: [
        { name: 'Ladies Cut and Finish', time: 60, price: 48 },
        { name: 'Blow Dry', time: 45, price: 30 },
        { name: 'Gents Cut', time: 30, price: 22 },
      ] },
      { name: 'Colour', services: [
        { name: 'Full Head Colour', time: 120, price: 75 },
        { name: 'Half Head Highlights', time: 120, price: 85 },
        { name: 'Balayage', time: 180, price: 130 },
        { name: 'Toner', time: 30, price: 25 },
      ] },
      { name: 'Treatments', services: [
        { name: 'Conditioning Treatment', time: 30, price: 20 },
      ] },
    ],
  },
  nail_salon: {
    label: 'nail salons',
    categories: [
      { name: 'Gel', services: [
        { name: 'Gel Manicure', time: 45, price: 30 },
        { name: 'Gel Pedicure', time: 60, price: 35 },
        { name: 'Builder Gel', time: 60, price: 38 },
      ] },
      { name: 'Extensions', services: [
        { name: 'Acrylic Full Set', time: 90, price: 45 },
        { name: 'Infills', time: 60, price: 32 },
        { name: 'Removal', time: 20, price: 10 },
      ] },
    ],
  },
  beauty_salon: {
    label: 'beauty salons',
    categories: [
      { name: 'Brows and Lashes', services: [
        { name: 'Brow Wax', time: 15, price: 10 },
        { name: 'Brow Lamination', time: 45, price: 40 },
        { name: 'Lash Lift and Tint', time: 60, price: 45 },
        { name: 'Classic Lashes', time: 90, price: 55 },
      ] },
      { name: 'Waxing and Skin', services: [
        { name: 'Full Leg Wax', time: 45, price: 30 },
        { name: 'Facial', time: 60, price: 50 },
      ] },
    ],
  },
  spa: {
    label: 'spas',
    categories: [
      { name: 'Massage', services: [
        { name: 'Swedish Massage', time: 60, price: 60 },
        { name: 'Deep Tissue Massage', time: 60, price: 65 },
        { name: 'Hot Stone Massage', time: 75, price: 75 },
        { name: 'Back, Neck and Shoulder', time: 30, price: 38 },
      ] },
      { name: 'Face and Body', services: [
        { name: 'Signature Facial', time: 60, price: 65 },
        { name: 'Body Scrub', time: 45, price: 50 },
      ] },
    ],
  },
};

/** The picker order for "Other" or an unknown type. */
export const STARTER_MENU_CHOICES = [
  { id: 'hair_salon', label: 'Hair salon' },
  { id: 'barber', label: 'Barbershop' },
  { id: 'beauty_salon', label: 'Beauty' },
  { id: 'nail_salon', label: 'Nails' },
  { id: 'spa', label: 'Spa' },
];

export const hasStarterMenu = (type) => !!STARTER_MENUS[type];

/**
 * Editable rows for the starter screen. Every row is ticked by default.
 * `price` is a string so the input can be emptied while typing.
 */
export function starterRows(type, { withPrices = true } = {}) {
  const menu = STARTER_MENUS[type];
  if (!menu) return [];
  const rows = [];
  menu.categories.forEach((cat) => {
    cat.services.forEach((svc, i) => {
      rows.push({
        key: `${type}:${cat.name}:${i}`,
        category: cat.name,
        name: svc.name,
        time: svc.time,
        price: withPrices ? String(svc.price) : '',
        on: true,
      });
    });
  });
  return rows;
}

/** Where the salon's businessType lives on the logged-in user. */
export function salonBusinessType(user) {
  const h = user && user.userInfo && user.userInfo.hairdresser;
  return (h && h.salon && h.salon.businessType) || (h && h.businessType) || '';
}
